import React from 'react';
import { Base, Skeleton } from 'lib/cortiUI';
export function AudioLoader() {
    return (React.createElement(Base, null,
        React.createElement(Skeleton, { height: 45, variant: "rounded", sx: { borderRadius: 100 } })));
}
